module.exports = __webpack_public_path__ + "img/success_OLD_2.daf46230.gif";